// extracted by mini-css-extract-plugin
module.exports = {"notification":"style_notification__3s3IV","info":"style_info__2Qe3Q","success":"style_success__2oecG","warning":"style_warning__1oOyt","muted":"style_muted__27AFJ"};